import { ConfigurationSchema } from '@jbrowse/core/configuration';
import { baseLinearDisplayConfigSchema } from '../BaseLinearDisplay';
/**
 * #config LinearBasicDisplay
 */
function configSchemaFactory(pluginManager) {
  return ConfigurationSchema('LinearBasicDisplay', {
    /**
     * #slot
     */
    mouseover: {
      type: 'string',
      description: 'what to display in a given mouseover',
      defaultValue: "jexl:get(feature,'name')",
      contextVariable: ['feature']
    },
    /**
     * #slot
     */
    renderer: pluginManager.pluggableConfigSchemaType('renderer')
  }, {
    /**
     * #baseConfiguration
     */
    baseConfiguration: baseLinearDisplayConfigSchema,
    explicitlyTyped: true
  });
}
export default configSchemaFactory;